import React, { useEffect, useState } from 'react';
import './style.css'
import { Button, Col, Collapse, Form, Modal, Row } from 'react-bootstrap';
import { FormGroup } from '../../components/FormGroup';
import { Label } from '../../components/Label';
import { CardContent } from '../../components/CardContent';
import { Title } from '../../components/Title';
import { Subtitle } from '../../components/SubTitle';
import { TBody, TCell, TGroup, THeader, TRow, Table, ThCell } from '../../components/Table/Table';
import api from '../../services/api';
import { Autocomplete, Box, CircularProgress, IconButton, LinearProgress, Skeleton, TextField, TextareaAutosize, Tooltip, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import _ from 'lodash'; // Importando lodash para o debounce
import { NiveisAcesso } from '../../constants/niveisAcesso';
import { Modal as MaterialModal } from '@mui/material';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import { useLocation } from 'react-router-dom';

interface Risco {
    id: string;
    nome: string;
}

export function Pcmso({ triggerUpdate, updateTrigger, idEmpresa, idFdt, idRevisao, idGhe, UpdateComplete, selectedEmissaoId, documento, listaDeRiscos, externoPgr, externoPcmso, enviado }: any) {
    const [showForm, setShowForm] = useState(false);
    const [baseExames, setBaseExames] = useState([]);
    const [fetchedExams, setFetchedExams] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedExamId, setSelectedExamId] = useState(null);
    const [posAdmissional, setPosAdmissional] = useState('');
    const [riscoSelecionadoParaExame, setRiscoSelecionadoParaExame]: any = useState(null);
    const [exame, setExame] = useState('');
    const [checkbox, setCheckbox] = useState('');
    const [antes, setAntes] = useState('');
    const [aPartir, setAPartir] = useState('');
    const [periodico, setPeriodico] = useState('');
    const [ate, setAte] = useState('');
    const [depois, setDepois] = useState('');
    const [riscosSelecionados, setRiscosSelecionados] = useState<Risco[]>([]);
    const [selectedExam, setSelectedExam]: any = useState(null);
    const [manuallyAddedExamIds, setManuallyAddedExamIds]: any = useState([]);
    const [showHelpModal, setShowHelpModal] = useState(false);
    const [quarentenaExames, setQuarentenaExames]: any = useState([]);

    const location = useLocation();
    const pathName = location.pathname;
    const routeName = pathName.substring(pathName.lastIndexOf('/') + 1).toUpperCase();

    const [tipoExame, setTipoExame] = useState({
        admissional: false,
        demissional: false,
        retornoTrabalho: false,
        mudancaFuncao: false,
    });

    const [nivelAcesso, setNivelAcesso] = useState(0)
    const nomesUnicos = new Set();

    useEffect(() => {


        const fetchNivelAcesso = async () => {
            try {
                const response = await api.get('nivel-acesso');
                setNivelAcesso(response.data.nivel);
            } catch (error) {
                console.error('Erro ao buscar nível de acesso:', error);
            }
        };

        fetchNivelAcesso();
    }, []);

    useEffect(() => {
        const buscarExames = async () => {
            try {
                const response = await api.post('buscar-exames-cadastrados', selectedExam.id);

                if (response) {
                    const responseData = response.data;

                    setPeriodico(responseData.periodicidade ? responseData.periodicidade : '');
                    setPosAdmissional(responseData.apos_adm ? responseData.apos_adm : '');
                    setAPartir(responseData.per_id1 ? responseData.per_id1 : '');
                    setAte(responseData.per_id2 ? responseData.per_id2 : '');
                    setAntes(responseData.periodicidade_a ? responseData.periodicidade_a : '');
                    setDepois(responseData.periodicidade_d ? responseData.periodicidade_d : '');

                    setTipoExame({
                        admissional: responseData.adm,
                        demissional: responseData.dem,
                        retornoTrabalho: responseData.ret_tra,
                        mudancaFuncao: responseData.mud_fun
                    });
                }

            } catch (error) {
                console.log(error);
            }
        };

        buscarExames();
    }, [selectedExam]);

    useEffect(() => {
        api.post('get-quarentena-exames', fetchedExams).then((response: any) => {
            const examesQuarentena = response.data.flat();
            setQuarentenaExames(examesQuarentena);
        })
    }, [fetchedExams]);

    // Em algum lugar no seu código, você vai precisar de manipuladores para esses estados, como exemplo:
    const handleCheckboxChange = (e: any) => {
        const { name, checked } = e.target;
        setTipoExame(prevTipoExame => ({
            ...prevTipoExame,
            [name]: checked
        }));
    };



    const handleDeleteExame = async (exame: any) => {
        setLoading(true);
        try {
            await api.post(`excluir-exame`, { exame: exame, id_revisao: idRevisao, riscos: listaDeRiscos });
            fetchExams();
        } catch (error) {
            console.error("Erro ao excluir exame:", error);
        } finally {
            setLoading(false);
        }
    };

    const mesesOpcoes = [
        { label: '3 meses', value: "3" },
        { label: '6 meses', value: "6" },
        { label: '12 meses', value: "12" },
        { label: '24 meses', value: "24" },
        { label: '36 meses', value: "36" },
        { label: '48 meses', value: "48" },
        { label: '60 meses', value: "60" },
    ];

    const idadeOpcoes = [{ label: 'N', value: 0 }, ...Array.from({ length: 84 }, (_, i) => ({ label: `${i + 16}`, value: i + 16 }))]; // Gera um array de 'N' até '99'

    const fetchExams = async () => {
        if (!idRevisao) return; // Ensure there's an idRevisao to fetch for
        setLoading(true);
        try {
            const payload = {
                id_revisao: idRevisao,
                riscos: listaDeRiscos
            }
            const response = await api.post('listar-exames', payload);
            console.log("🚀 ~ fetchExams ~ response:", response.data)
            setFetchedExams(response.data);
        } catch (error) {
            console.error("Erro ao buscar exames por revisão:", error);
            setFetchedExams([]);
        } finally {
            setLoading(false);
        }

    };

    useEffect(() => {
        if (listaDeRiscos.length > 0) {
            fetchExams();
        }
    }, [listaDeRiscos]);

    const filteredFetchedExams = fetchedExams.filter((exame: any, index, self) =>
        index === self.findIndex((e: any) => e.ateBaseExames.nome === exame.ateBaseExames.nome)
    );

    const toggleFormVisibility = () => {
        setShowForm(!showForm);
    };
    const debouncedFetchExames = _.debounce(async (nome: string) => {
        if (!nome) return; // Evita buscar se não houver input
        setLoading(true);
        try {
            const response = await api.get(`listar-base-exames/${nome}`);
            setBaseExames(response.data);
        } catch (error) {
            console.error("Erro ao buscar exames:", error);
            setBaseExames([]);
        } finally {
            setLoading(false);
        }
    }, 500); // 500 ms de delay

    const resetForm = () => {
        setAPartir('');
        setAte('');
        setPeriodico('');
        setAntes('');
        setPosAdmissional('');
        setRiscosSelecionados([]);
        setSelectedExam(null);
        setExame('');

        setTipoExame({
            admissional: false,
            demissional: false,
            retornoTrabalho: false,
            mudancaFuncao: false,
        });
    };


    const handleSubmit = async (e: any) => {
        e.preventDefault(); // Evita o comportamento padrão de envio do formulário

        // Objeto com os dados do formulário

        if (nivelAcesso == NiveisAcesso.ADMIN) {
            const formData = {
                id_base_exames: selectedExam ? selectedExam.id : null,
                id_revisao: idRevisao,
                adm: tipoExame.admissional ? 1 : 0,
                apos_adm: posAdmissional || 0,
                dem: tipoExame.demissional ? 1 : 0,
                ret_tra: tipoExame.retornoTrabalho ? 1 : 0,
                mud_fun: tipoExame.mudancaFuncao ? 1 : 0,
                periodicidade_a: antes || 0,
                per_id1: aPartir || 0,
                periodicidade: periodico || 0,
                per_id2: ate || 0,
                periodicidade_d: depois || 0,
                riscos: riscoSelecionadoParaExame,
                nivelAcesso: nivelAcesso,
                inserirPcmso: true
            };

            const payload = {
                riscos: riscosSelecionados,
                exames: selectedExam,
            };

            try {
                const response = await api.post(`inserir-exame-pcmso`, formData);
                await api.post('vincular-risco-exame', payload);

                fetchExams();

                if (response.data && response.data.id) {
                    setManuallyAddedExamIds((prevIds: any) => [...prevIds, response.data.id]);
                }

            } catch (error) {
                console.error("Erro ao inserir exame:", error);
            } finally {
                resetForm();
            }
        } else {
            try {
                const formData = {
                    id: selectedExam.id,
                    idRevisao: idRevisao,
                    id_risco: riscoSelecionadoParaExame.id
                }

                await api.post(`inserir-exame-geral`, formData);
                fetchExams();

            } catch (error) {
                console.error("Erro ao inserir exame:", error);
            } finally {
                resetForm();
            }
        }

    };

    const formatarPeriodicidade = (exame: any) => {
        const partes = [];
        const { periodicidade_a, per_id1, periodicidade, per_id2, Periodicidade_d } = exame;

        // Antes
        if (periodicidade_a > 0 && per_id1 > 0) {
            partes.push(`${periodicidade_a} meses até ${per_id1} anos`);
        }

        // Periodicidade entre "a partir" e "até"
        if (periodicidade > 0 && per_id1 > 0 && per_id2 > 0) {
            partes.push(`${periodicidade} meses de ${per_id1} anos até ${per_id2} anos`);
        } else if (periodicidade > 0 && per_id1 === 0 && per_id2 > 0) {
            // Caso especial onde só temos "até"
            partes.push(`${periodicidade} meses até ${per_id2} anos`);
        } else if (periodicidade > 0 && per_id1 > 0 && per_id2 === 0) {
            // Caso especial onde só temos "a partir"
            partes.push(`${periodicidade} meses a partir de ${per_id1} anos`);
        } else if (periodicidade > 0 && per_id1 === 0 && per_id2 === 0) {
            // Caso especial onde só temos periodicidade
            partes.push(`${periodicidade} meses`);
        }

        // Depois
        if (Periodicidade_d > 0 && per_id2 > 0) {
            partes.push(`${Periodicidade_d} meses a partir de ${per_id2} anos`);
        }

        return partes.join(', ');
    };


    const riscosFiltrados = Array.isArray(listaDeRiscos) ? listaDeRiscos.filter((risco: any) => {
        if (!nomesUnicos.has(risco.risco)) {
            nomesUnicos.add(risco.risco);
            return true;
        }
        return false;
    }).map((risco: any) => ({
        id: risco.id,
        nome: risco.risco
    })) : [];

    const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const value = event.target.value as keyof typeof tipoExame;
        setTipoExame(prev => ({
            ...prev,
            admissional: false,
            demissional: false,
            retornoTrabalho: false,
            mudancaFuncao: false,
            [value]: true,
        }));
    };

    const getSelectedValue = (): string => {
        const selected = Object.keys(tipoExame).find((key): key is keyof typeof tipoExame => tipoExame[key as keyof typeof tipoExame]);
        return selected || '';
    };

    const handleCloseHelpModal = () => {
        setShowHelpModal(false);
    };

    const formHeight = nivelAcesso === NiveisAcesso.ADMIN ? '400px' : '150px';

    const getExternoBasedOnRoute = () => {
        if (routeName === 'PGR') {
            return externoPgr;
        } else if (routeName === 'PCMSO') {
            return externoPcmso;
        }
        return null;
    };

    const externo = getExternoBasedOnRoute();

    return (
        <div className='py-4'>
            {/* {externo == 1 ? (
                <div style={{ position: 'relative', width: '100%' }}>
                    <Skeleton variant="rectangular" width="100%" height={300} animation="wave" style={{ backgroundColor: '#E6E6E6', borderRadius: '10px' }} />
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '100%',
                        textAlign: 'center',
                        color: 'grey',
                        fontSize: '20px',
                        fontWeight: 'bold'
                    }}>

                        Para mais funcionalidades, adquira uma revisão ou inicie uma nova frente de trabalho.
                    </div>
                </div>

            ) : ( */}
            <CardContent>

                <Row>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%'
                    }}>
                        <Title text="Exames" />
                        <Button
                            style={{
                                width: '40px',
                                borderRadius: '20px',
                            }}
                            onClick={() => setShowHelpModal(true)}>
                            ?
                        </Button>
                    </Box>
                    <p style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: '0.2%' }}>Ajuda</p>
                </Row>
                {((externo != 1 && enviado != 1) || nivelAcesso == NiveisAcesso.ADMIN) && (
                    <>
                        <Row>
                            <Col sm={2}>
                                <Button variant='primary' onClick={toggleFormVisibility} style={{ marginLeft: "0" }}>
                                    Inserir Exames
                                    <ExpandMoreIcon />
                                </Button>
                            </Col>
                        </Row>
                        <Row >

                            <form onSubmit={handleSubmit} className={showForm ? "collapsePcmso" : "notCollapsePcmso"} style={{ height: showForm ? formHeight : '0 !important', overflowY: 'auto', transition: '.3s' }}>
                                <Row style={{ marginBottom: '20px' }}>
                                    {nivelAcesso == NiveisAcesso.ADMIN ? (
                                        <>
                                            <Col sm={6} className='nameInput'>
                                                <FormGroup className='form-group-dsg'>
                                                    <Label title="RISCOS (DIGITE E SELECIONE)" htmlFor="exa" />
                                                    <Autocomplete
                                                        key={selectedExamId ? selectedExamId : 'empty'}
                                                        value={riscoSelecionadoParaExame}
                                                        onChange={(event, newValue) => {
                                                            setRiscoSelecionadoParaExame(newValue);
                                                        }}
                                                        noOptionsText="Digite e selecione"
                                                        style={{ width: '100%', height: '40px' }}
                                                        getOptionLabel={(option: any) => option.nome}
                                                        renderInput={(params) => <TextField {...params} label="" />}
                                                        options={riscosFiltrados}
                                                        isOptionEqualToValue={(option, value) => option.id === value.id} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6} className='nameInput'>
                                                <FormGroup className='form-group-dsg'>
                                                    <Label title="Nome (DIGITE E SELECIONE)" htmlFor="exa" />
                                                    <Autocomplete
                                                        key={selectedExam ? selectedExam.id : 'empty'}
                                                        value={selectedExam}
                                                        noOptionsText="Digite e selecione"
                                                        style={{ width: '100%', height: '40px' }}

                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label=""

                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    endAdornment: (
                                                                        <>
                                                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                                            {params.InputProps.endAdornment}
                                                                        </>
                                                                    ),
                                                                }} />
                                                        )}
                                                        options={baseExames.map((exame: any) => ({ label: exame.nome, id: exame.id }))}
                                                        getOptionLabel={(option) => option.label}
                                                        onChange={(event, newValue) => {
                                                            setSelectedExam(newValue); // Aqui guardamos o objeto inteiro do exame
                                                        }}
                                                        onInputChange={(event, newValue) => {
                                                            debouncedFetchExames(newValue);
                                                        }}
                                                        isOptionEqualToValue={(option, value) => option.id === value.id} />
                                                </FormGroup>
                                            </Col>
                                        </>
                                    ) : (
                                        <>
                                            <Col md={4} style={{ marginTop: '20px' }}>
                                                <FormGroup className='form-group-dsg'>
                                                    <Label title="RISCOS (DIGITE E SELECIONE)" htmlFor="exa" />
                                                    <Autocomplete
                                                        key={selectedExamId ? selectedExamId : 'empty'}
                                                        value={riscoSelecionadoParaExame}
                                                        onChange={(event, newValue) => {
                                                            setRiscoSelecionadoParaExame(newValue);
                                                        }}
                                                        noOptionsText="Digite e selecione"
                                                        style={{ width: '100%', height: '40px' }}
                                                        getOptionLabel={(option: any) => option.nome}
                                                        renderInput={(params) => <TextField {...params} label="" />}
                                                        options={riscosFiltrados}
                                                        isOptionEqualToValue={(option, value) => option.id === value.id} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={4} style={{ marginTop: '20px' }}>
                                                <FormGroup className='form-group-dsg'>
                                                    <Label title="Nome (DIGITE E SELECIONE)" htmlFor="exa" />
                                                    <Autocomplete
                                                        key={selectedExam ? selectedExam.id : 'empty'}
                                                        value={selectedExam}
                                                        noOptionsText="Digite e selecione"
                                                        style={{ width: '100%', height: '40px' }}

                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label=""

                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    endAdornment: (
                                                                        <>
                                                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                                            {params.InputProps.endAdornment}
                                                                        </>
                                                                    ),
                                                                }} />
                                                        )}
                                                        options={baseExames.map((exame: any) => ({ label: exame.nome, id: exame.id }))}
                                                        getOptionLabel={(option) => option.label}
                                                        onChange={(event, newValue) => {
                                                            setSelectedExam(newValue); // Aqui guardamos o objeto inteiro do exame
                                                        }}
                                                        onInputChange={(event, newValue) => {
                                                            debouncedFetchExames(newValue);
                                                        }}
                                                        isOptionEqualToValue={(option, value) => option.id === value.id} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={2} className='flex align-center justify-flex-end' style={{ marginTop: '20px' }}>
                                                <Button style={{ width: '100%', height: '40px', marginTop: '30px' }} type="submit">
                                                    <InsertLinkIcon style={{ marginRight: '5px' }} />
                                                    Salvar
                                                </Button>
                                            </Col>
                                        </>
                                    )}
                                </Row>
                                {nivelAcesso == NiveisAcesso.ADMIN && (
                                    <>
                                        <Row>
                                            <Col style={{ marginTop: '10px', marginBottom: '10px' }}>
                                                <Col>
                                                    <input
                                                        key={checkbox}
                                                        type="checkbox"
                                                        name="admissional"
                                                        onChange={handleCheckboxChange}
                                                        checked={tipoExame.admissional}
                                                        style={{ marginRight: '10px' }}
                                                    />
                                                    <Label title="Admissional" htmlFor="posAdm" />
                                                </Col>
                                                <Col>
                                                    <input
                                                        key={checkbox}
                                                        type="checkbox"
                                                        name="demissional"
                                                        onChange={handleCheckboxChange}
                                                        checked={tipoExame.demissional}
                                                        style={{ marginRight: '10px' }}
                                                    />
                                                    <Label title="Demissional" htmlFor="posAdm" />
                                                </Col>

                                                <Col>

                                                    <input
                                                        key={checkbox}
                                                        type="checkbox"
                                                        name="retornoTrabalho"
                                                        onChange={handleCheckboxChange}
                                                        checked={tipoExame.retornoTrabalho}
                                                        style={{ marginRight: '10px' }}
                                                    />
                                                    <Label title="Retorno ao Trabalho" htmlFor="posAdm" />
                                                </Col>
                                                <Col>

                                                    <input
                                                        key={checkbox}
                                                        type="checkbox"
                                                        name="mudancaFuncao"
                                                        onChange={handleCheckboxChange}
                                                        checked={tipoExame.mudancaFuncao}
                                                        style={{ marginRight: '10px' }}
                                                    />
                                                    <Label title="Mudança de Risco Ocupacional" htmlFor="posAdm" />
                                                </Col>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={4}>
                                                <FormGroup>
                                                    <Label title="Pós Admissional" htmlFor="posAdm" />
                                                    <Form.Select id="posAdm" value={posAdmissional} onChange={(e) => setPosAdmissional(e.target.value)}>
                                                        <option value="">Selecione</option>
                                                        <option value="3">3 meses</option>
                                                        <option value="6">6 meses</option>
                                                    </Form.Select>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            {(aPartir && ate) && (
                                                <Col md={2}>
                                                    <FormGroup>
                                                        <Label title="Antes" htmlFor="antes" />
                                                        <Form.Select id="antes" value={antes || ''} onChange={(e) => setAntes(e.target.value)}>
                                                            <option value="">Selecione</option>
                                                            {mesesOpcoes.map((opcao) => (
                                                                <option key={opcao.label} value={opcao.value}>{opcao.label}</option>
                                                            ))}
                                                        </Form.Select>
                                                    </FormGroup>
                                                </Col>
                                            )}
                                            {periodico && (
                                                <Col md={2}>
                                                    <FormGroup>
                                                        <Label title="A partir" htmlFor="aPartir" />
                                                        <Form.Select id="aPartir" value={aPartir} onChange={(e) => setAPartir(e.target.value)}>
                                                            <option value="">Selecione</option>
                                                            {idadeOpcoes.map((opcao) => (
                                                                <option key={opcao.label} value={opcao.value}>{opcao.label}</option>
                                                            ))}
                                                        </Form.Select>
                                                    </FormGroup>
                                                </Col>
                                            )}
                                            <Col md={2}>
                                                <FormGroup>
                                                    <Label title="Periódico" htmlFor="periodico" />
                                                    <Form.Select id="periodico" value={periodico} onChange={(e) => {
                                                        setPeriodico(e.target.value);
                                                    }}>
                                                        <option value="">Selecione</option>
                                                        {mesesOpcoes.map((opcao) => (
                                                            <option key={opcao.label} value={opcao.value}>{opcao.label}</option>
                                                        ))}
                                                    </Form.Select>
                                                </FormGroup>
                                            </Col>

                                            {(periodico && periodico != '0') && (
                                                <Col md={2}>
                                                    <FormGroup>
                                                        <Label title="Até" htmlFor="ate" />
                                                        <Form.Select id="ate" value={ate} onChange={(e) => setAte(e.target.value)}>
                                                            <option value="">Selecione</option>
                                                            {idadeOpcoes.map((opcao) => (
                                                                <option key={opcao.label} value={opcao.value}>{opcao.label}</option>
                                                            ))}
                                                        </Form.Select>
                                                    </FormGroup>
                                                </Col>
                                            )}

                                            {(aPartir && ate) && (
                                                <Col md={2}>
                                                    <Label title="Depois" htmlFor="ate" />
                                                    <Form.Select id="depois" value={depois || ''} onChange={(e) => setDepois(e.target.value)}>
                                                        <option value="">Selecione</option>
                                                        {mesesOpcoes.map((opcao) => (
                                                            <option key={opcao.label} value={opcao.value}>{opcao.label}</option>
                                                        ))}
                                                    </Form.Select>
                                                </Col>
                                            )}
                                        </Row>
                                        <Row>
                                            <Col md={1} className='submitButton'>
                                                <Button className='btn-success' type="submit" style={{ marginTop: '10px' }}>
                                                    Inserir
                                                </Button>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                            </form>
                        </Row>

                    </>
                )}


                <Row>
                    <Col md={8} style={{ paddingTop: '5px' }}>
                        <Subtitle text="Exames cadastrados" />
                    </Col>
                    <Col md={12}>
                        <div style={{ border: '1px solid #007bff', borderRadius: '6px', overflow: 'hidden' }}>
                            <div style={{ maxHeight: '250px', overflow: 'auto' }}>
                                <table className="exame-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead style={{ background: '#007bff', color: 'white', position: 'sticky', top: 0, zIndex: 1 }}>
                                        <tr>
                                            <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Nome</th>
                                            <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Admissional</th>
                                            <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Após Admissional</th>
                                            <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Demissional</th>
                                            <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Ret. Tra.</th>
                                            <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Mud. Fun.</th>
                                            <th style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>Periódico</th>
                                            <th style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredFetchedExams.map((exame: any) => {
                                            let isQuarentenaExame = false;
                                            if (nivelAcesso === NiveisAcesso.ADMIN) {
                                                isQuarentenaExame = quarentenaExames.some((q: any) => q.id_registro === exame.id);
                                            }
                                            return (
                                                <tr key={exame.id} className={isQuarentenaExame ? 'quarentena-error' : ''}>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                        {exame.ateBaseExames.nome}
                                                    </td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                        {exame.adm ? "Sim" : "Não"}
                                                    </td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                        {exame.apos_adm ? `${exame.apos_adm} meses` : "Não"}
                                                    </td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                        {exame.dem ? "Sim" : "Não"}
                                                    </td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                        {exame.ret_tra ? "Sim" : "Não"}
                                                    </td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                        {exame.mud_fun ? "Sim" : "Não"}
                                                    </td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                        {formatarPeriodicidade(exame) && formatarPeriodicidade(exame) !== '' ? formatarPeriodicidade(exame) : '-'}
                                                    </td>
                                                    {(exame.excluivel === 1 || nivelAcesso === NiveisAcesso.ADMIN) && (
                                                        <td style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal', borderTop: '1px solid lightgray' }}>
                                                            {((externo != 1 && enviado != 1) || nivelAcesso == NiveisAcesso.ADMIN) && (
                                                                <>
                                                                    <Button
                                                                        variant="danger"
                                                                        onClick={() => handleDeleteExame(exame)}
                                                                        style={{ backgroundColor: 'red', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px' }}
                                                                    >
                                                                        Excluir
                                                                    </Button>
                                                                </>
                                                            )}
                                                        </td>
                                                    )}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Col>
                </Row>
            </CardContent>
            {/* )} */}


            <MaterialModal
                open={showHelpModal}
                onClose={handleCloseHelpModal}
                style={{ backdropFilter: 'blur(10px)' }}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'block',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '700px',
                    maxWidth: '90%',
                    maxHeight: '80%'
                }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                        <h4>AJUDA</h4>
                        <p>
                            <b>Cadastro / Listagem de Exames:</b>
                        </p>
                        <p>
                            <b>Inserir Exames: </b> O usuário poderá adicionar um exame que não esteja na listagem.
                        </p>
                        <p>
                            <b>Listagem de Exames:</b>
                            Após o registro dos exames, estes serão exibidos em uma tabela com os seguintes campos: Nome, Risco, Admissional, Após Admissional, Demissional, Retorno ao Trabalho,
                            Mudança de Risco Ocupacional e Periódico. Se houver riscos associados às funções específicas do PCMSO, os exames relacionados a esses riscos serão listados.
                        </p>
                        <p>
                            <b>Exclusão de Exames:</b> Caso um exame esteja previamente vinculado a um risco cadastrado o usuário não poderá excluí-lo. A exclusão ou edição será permitida somente para exames que tenham sido cadastrados manualmente.
                        </p>
                    </Box>
                </Box>
            </MaterialModal>

        </div >
    );

}